import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import TrustedBy from '../components/TrustedBy';
import ServicesOverview from '../components/ServicesOverview';
import Testimonials from '../components/Testimonials';
import FaqHome from '../components/FaqHome';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>PH Therapy | Expert Exercise Physiology & Rehabilitation</title>
        <meta name="description" content="PH Therapy offers expert exercise physiology and rehabilitation for partners, CEOs, and professionals. MSK, oncology, lifestyle management. London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex. Book a consultation." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/" />
      </Helmet>
      <Header />
      <Hero />
      <Intro />
      <TrustedBy variant="combined" />
      <ServicesOverview />
      <Testimonials />
      <FaqHome />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
